import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import NotPaid from "../../utilities/not-paid";
import NotUser from "../../utilities/not-user";
import { useState } from "react";
import UserList from "./features/allusers";


const Dashboard = () => {
    const navigate = useNavigate();

    const company = Cookies.get(`token_company`);
    const email = Cookies.get(`token_email`);
    const firstname = Cookies.get(`token_first_name`);
    const lastname = Cookies.get(`token_last_name`);
    const phone = Cookies.get(`token_phone`);
    const [myCompany, setShowCompany] = useState(false);

    if (!firstname || !lastname || !company || !email || !phone) {
        return (
                <NotUser/>
        )
    }

    // const id = 

    const status = Cookies.get(`token_status`);


    if (status != 'Paid') {
        return (
            <NotPaid/>
        )
    }

    if (myCompany) {
        <UserList/>
    }
    return ( 
        <div>
            <h1 className="display-4  text-center text-muted fst-italic m-4">Lebang Nong 
                {
                    Cookies.get('token_admin') == 'yes' &&
                    <span style={{color:"green", opacity:"50%"}} className=" fs-6">      admin</span>
                }
                </h1>
            <div className="row justify-content-center text-center">
                {
                    Cookies.get('token_admin') == 'yes' &&
                    <div onClick={() => {
                        navigate('/edit/payment')
                    }} className="btn col-4 card m-1 p- border-primary justify-content-center" style={{
                        height: "25svh"
                    }}> 
                    <div className="card-title fw-lighter fs-4 fst-italic text-primary" >Update payment</div></div>
                }
                <div onClick={() => {
                        navigate('/edit/user')
                    }} className="btn col-4 card m-1 border-primary justify-content-center" style={{
                    height: "25svh"
                }}> 
                <div className="card-title fw-lighter fs-4 fst-italic text-primary">Edit my details <br/></div></div>
                {/* <div  onClick={() => {
                        navigate('/edit/blacklist')
                    }}className="btn col-4 card m-1 border-primary justify-content-center" style={{
                    height: "25svh"
                }}> 
                <div className="card-title fw-lighter fs-4 fst-italic text-primary">Edit blacklist details <br/></div></div>*/}
                <div  onClick={() => {
                        navigate('/company')
                    }}className="btn col-4 card m-1 border-primary justify-content-center" style={{
                    height: "25svh"
                }}> 
                <div className="card-title fw-lighter fs-4 fst-italic text-primary">My company<br/></div></div>
                 
                
            </div>
        </div>
     );
}
 
export default Dashboard;